<template>
  <div class="w-full">
    <SparkMultiFilter
      name="processes"
      label="Process"
      placeholder="Select processes"
      :options="processOptions"
      v-model="selectedProcessValues"
    />
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import SparkMultiFilter from '@/components/SparkComponents/SparkMultiFilter.vue';

export default {
  name: 'ProcessFilter',

  components: {
    SparkMultiFilter,
  },

  props: {
    reset: { type: Number, required: true },
    parent: { type: String, required: true },
  },

  emits: ['selected'],

  data() {
    return {
      selectedProcessValues: [],
      processOptions: [],
    };
  },

  computed: {
    ...mapState(['partLibraryFilters']),
    ...mapState('application', ['axiosInstance']),
  },

  watch: {
    selectedProcessValues: {
      handler(newVal) {
        // Convert selected process names to the expected format with index as process_id
        const selectedProcessesFormatted = newVal.map(processName => {
          const optionIndex = this.processOptions.findIndex(option => option.value === processName);
          return {
            process_id: optionIndex,
            name: processName,
          };
        });
        this.$emit('selected', { processes: selectedProcessesFormatted });
      },
      deep: true,
    },

    reset: {
      handler() {
        if (this.reset) {
          this.clear();
        }
      },
    },
  },

  async mounted() {
    await this.getProcesses();
    try {
      const filter = JSON.parse(sessionStorage.getItem('libraryFilter'));
      if (this.parent === 'library') {
        const selected = filter?.processes;
        if (selected?.length) {
          // Extract process names from the selected processes
          this.selectedProcessValues = selected.map(process => process.name);
        }
      }
    } catch (error) {
      console.warn('Could not parse libraryFilter from sessionStorage:', error);
    }
  },

  methods: {
    ...mapMutations(['resetFilter']),

    async getProcesses() {
      await this.axiosInstance
        .get('/api/v1/process-chain-dropdown/')
        .then(response => {
          this.processOptions = response.data
            .filter(name => name !== null)
            .map(name => ({
              value: name, // Use the actual process name as the value
              label: name,
            }));
        })
        .catch(error => {
          console.log(error);
        });
    },

    clear() {
      this.resetFilter({ processes: 'processes' });
      this.selectedProcessValues = [];
    },
  },
};
</script>

<style scoped lang="scss">
</style>
